
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#474747","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-width":"15"}},[_c('path',{attrs:{"d":"M132.656 262.024V61.69c0-13.735 11.134-24.869 24.869-24.869h0c13.735 0 24.869 11.134 24.869 24.869v170.844m49.738 0V61.69c0-13.735 11.134-24.869 24.869-24.869h0c13.735 0 24.869 11.134 24.869 24.869v145.844M310.152 463.646v29.512"}}),_c('path',{attrs:{"d":"M281.869 202.534V88.997c0-13.735 11.134-24.869 24.869-24.869h0c13.735 0 24.869 11.134 24.869 24.869v130.649m-149.213 12.888V45.111c0-13.735 11.134-24.869 24.869-24.869h0c13.735 0 24.869 11.134 24.869 24.869v187.423m14.628 111.411s-6.827-72.168-114.104-72.168l-34.134-30.233-12.349-49.002c-4.966-20.078-25.657-31.975-45.508-26.165l-4.559 1.049 15.223 76.693a48.144 48.144 0 004.781 13.631l33.07 63.157a48.257 48.257 0 0011.789 14.493l41.299 33.489a27.393 27.393 0 019.892 21.073v103.196m271.231-43.54l-43.784 35.027-43.784-35.027a143.124 143.124 0 01-53.716-111.763v-100.21l5.87 2.253a119.888 119.888 0 0087.084-.453l4.546-1.8 7.088 2.644a119.88 119.88 0 0087.192-1.33l3.219-1.314v100.21a143.12 143.12 0 01-53.715 111.763z"}}),_c('path',{attrs:{"d":"M336.107 359.646l20.5 20.5 74-74"}})])])
          )
        }
      }
    